import React, { Dispatch, SetStateAction } from 'react';
import { NotificationToggle } from './components/NotificationToggle';
import { Table } from '@shape-ds/components';
import { buildColumnsObject, EmptyMessage } from '@shape/lighthouse-components';
import { notificationListColumns } from './components/notificationListColumns';
import { useTranslation } from 'react-i18next';
import { notificationListMock } from 'mirage/notifications.mock';
import { NotificationItemPayload } from 'queries/notifications/contract';
import './NotificationList.scss';

interface NotificationListProps {
  setActiveTab: Dispatch<SetStateAction<number>>;
}

const NotificationsList: React.FC<NotificationListProps> = ({ setActiveTab }) => {
  const isLoading = false;
  const data: NotificationItemPayload[] = notificationListMock;

  const { t } = useTranslation();

  const columns = buildColumnsObject<NotificationItemPayload>({
    columns: notificationListColumns(),
    getLabel: (key: string) => t(`components:notifications.columns.${key}`),
  });

  return (
    <div className="notifications-manager-list">
      <NotificationToggle />
      {(data ?? []).length > 0 && !isLoading ? (
        <Table
          data={data ?? []}
          style={{ maxHeight: '300px' }}
          columns={columns}
          className="notifications-table"
          isLoading={isLoading}
        />
      ) : (
        <EmptyMessage
          message={t('components:notifications.empty')}
          textBtn={t('components:notifications.emptyLink')}
          onClickBtn={() => setActiveTab(1)}
          showIcon={false}
        />
      )}
    </div>
  );
};

export default NotificationsList;
